import { api } from '../lib/api';

export interface FilterGroupItem {
  id: string;
  name: string;
  values: string[];
}

export interface WorkspaceFilterGroup {
  id: string;
  workspaceId: string;
  name: string;
  field: string;
  dataSource?: {
    type?: 'google_sheets' | 'rest_api' | 'table';
    integrationId?: string;
    sourceColumn?: string;
    range?: string;
    tableComponentId?: string;
  };
  groups: FilterGroupItem[];
  createdAt: string;
  updatedAt: string;
}

export interface CreateWorkspaceFilterGroupPayload {
  name: string;
  field?: string;
  dataSource?: WorkspaceFilterGroup['dataSource'];
  groups?: FilterGroupItem[];
}

export interface UpdateWorkspaceFilterGroupPayload {
  name?: string;
  field?: string;
  dataSource?: WorkspaceFilterGroup['dataSource'];
  groups?: FilterGroupItem[];
}

export const workspaceFilterGroupsApi = {
  getAll: async (workspaceId: string): Promise<WorkspaceFilterGroup[]> => {
    const response = await api.get(`/workspaces/${workspaceId}/filter-groups`);
    return response.data;
  },

  getOne: async (workspaceId: string, id: string): Promise<WorkspaceFilterGroup> => {
    const response = await api.get(`/workspaces/${workspaceId}/filter-groups/${id}`);
    return response.data;
  },

  create: async (workspaceId: string, data: CreateWorkspaceFilterGroupPayload): Promise<WorkspaceFilterGroup> => {
    const response = await api.post(`/workspaces/${workspaceId}/filter-groups`, data);
    return response.data;
  },

  update: async (workspaceId: string, id: string, data: UpdateWorkspaceFilterGroupPayload): Promise<WorkspaceFilterGroup> => {
    const response = await api.patch(`/workspaces/${workspaceId}/filter-groups/${id}`, data);
    return response.data;
  },

  remove: async (workspaceId: string, id: string): Promise<void> => {
    await api.delete(`/workspaces/${workspaceId}/filter-groups/${id}`);
  },
};
